import { GetOccupancyLabelParams } from './getOccupancyLabel.types';

export function getOccupancyLabel(params: GetOccupancyLabelParams): string {

    const { adults = '0', children = '0', adultLabel, adultsLabel, childLabel, childrenLabel } = params;

    const occupancyLabel = [];
    const adultsNumber = Number(adults);
    const childrenNumber = Number(children);

    if (adultsNumber > 0 ) 
        adultsNumber === 1 
        ? occupancyLabel.push(`${adultsNumber} ${adultLabel}`) 
        : occupancyLabel.push(`${adultsNumber} ${adultsLabel}`);

    if (childrenNumber > 0 ) 
        childrenNumber === 1 
        ? occupancyLabel.push(`${childrenNumber} ${childLabel}`) 
        : occupancyLabel.push(`${childrenNumber} ${childrenLabel}`);

    return occupancyLabel.join(', ');
}

